import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import ReactAsyncSelect from "../controls/ReactAsyncSelect";
import api from '../../services/axios';
import { bankConcepts } from '../../services/bankConcepts';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import getBanks from '../../services/getBanks';
import getMovileurosAgents from '../../services/getMovileurosAgents';

const CreateBankEntry = (props) => {

  const { t } = useTranslation();
  const [date, setDate] = useState('')
  const [bankId, setBankId] = useState('')
  const [comment, setComment] = useState('')
  const [conceptId, setConceptId] = useState(null)
  const [agentId, setAgentId] = useState('')
  const [amount, setAmount] = useState(0)
  const navigate = useNavigate()
  const [banks, setBanks] = useState([])
  const [movileurosAgents, setMovileurosAgents] = useState([])

  const [errMsg, setErrMsg] = useState('');

  const store = async (e) => {
    e.preventDefault();
    try {
      await api.post('/bank_entries', {
        date: date,
        amount: amount,
        bankConceptId: conceptId ? conceptId : 1,
        bankId: bankId ? bankId :
        (props.loginParameters.company.includes('Demo')) ? 15 : 9,
        agentId: agentId,
        bankComment: comment,
      }, {
        headers: {
          'Authorization': `Bearer ${props.loginParameters.accesToken}`
        }
      })
      navigate('/bank_entries')
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
    }
  }

  const goBack = async (e) => {
    e.preventDefault();
    navigate('/bank_entries')
  }

  useEffect(() => {
    setDate(new Date().toISOString().slice(0, 10))
  }, [])

  useEffect(() => {
    getBanks(props.loginParameters.accesToken).then(banks => setBanks(banks))
  }, [props.loginParameters.accesToken])

  useEffect(() => {
    getMovileurosAgents(props.loginParameters.accesToken).then(movileurosAgents => setMovileurosAgents(movileurosAgents))
  }, [props.loginParameters.accesToken])

  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <h3 className="text-center mb-4">{t('banks.create_bank_entry')}</h3>
          <form>
            <div className='mb-3'>
              <label className='form-label'>{t('banks.bank')}</label>
              <Select
                options={banks}
                defaultValue={
                  (props.loginParameters.company.includes('Demo')) ? {
                    label: "Demo Bank 1",
                    value: 15
                  } : {
                    label: "Cajamar",
                    value: 9
                  }}
                onChange={(e) => setBankId(e.value)}
              />
            </div>
            <div className='mb-3'>
              <label className='form-label'>{t('banks.date')}</label>
              <input
                value={date}
                onChange={(e) => setDate(e.target.value)}
                type='date'
                className='form-control'
              />
            </div>
            <div className='mb-3'>
              <label className='form-label'>{t('banks.concept')}</label>
              <ReactAsyncSelect
                handleChange={(e) => setConceptId(e.value)}
                fetchData={bankConcepts}
                initialOption={{
                  label: "INGRESO CLIENTE EFECTIVO",
                  value: 1
                }}
              />
            </div>
            <div className='mb-3'>
              <label className='form-label'>{t('commercial_network.agent')}</label>
              <Select
                options={movileurosAgents}
                onChange={(e) => setAgentId(e ? e.value : '')}
                placeholder="Seleccionar agente..."
                isClearable
              />
            </div>
            <div className='mb-3'>
              <label className='form-label'>{t('banks.amount')}</label>
              <input
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                type='number'
                step="0.01"
                className='form-control'
              />
            </div>
            <div className='mb-3'>
              <label className='form-label'>{t('banks.comment')}</label>
              <input
                onChange={(e) => setComment(e.target.value)}
                type='text'
                className='form-control'
              />
            </div>

            <h4 className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</h4>

            <div className="d-flex justify-content-center gap-2 mt-4">
              <Button onClick={store} variant="success" type='submit'>{t('store')}</Button>
              <Button onClick={goBack} variant="primary" type='button'>{t('back')}</Button>
            </div>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default CreateBankEntry;
